export default __webpack_public_path__ + "static/media/IndigenousPeoples_en.3a082f96.svg";